import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestClientService } from 'src/app/common/service/rest-client.service';

@Injectable({
  providedIn: 'root'
})
export class DemoRemoteService {

  private URL = '/demo';

  constructor(
    private restClientService: RestClientService
  ) { }

  addNewDemo(request): Observable<any> {
    return this.restClientService.post(`${this.URL}/add-demo`, request);
  }
}
